export default __webpack_public_path__ + "static/media/tablet-curology-footer.bd12794d.jpg";